export default "---\nname: Jack Inglis\njob: CEO, AIMA\nimage: /assets/images/people/jack-inglis.jpg\nquote: The rise of retail alternative investing\n---\n";